import * as React from "react";
const SvgFiRrThunderstormSun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-thunderstorm-sun_svg__a)">
      <path
        fill="#062147"
        d="M15 24a1 1 0 0 1-.849-1.527L15.684 20h-2.069a1.627 1.627 0 0 1-1.546-2.082 1 1 0 0 1 .106-.235l1.973-3.207a1 1 0 1 1 1.7 1.048L14.328 18H16.4a1.6 1.6 0 0 1 1.336 2.489l-1.886 3.038A1 1 0 0 1 15 24m5-1a1 1 0 0 1-.222-1.975 3.09 3.09 0 0 0 .007-5.921 2.65 2.65 0 0 1-2.085-1.633 4 4 0 0 0-7.609 2.351 2.02 2.02 0 0 1-1.18 2.306 1.494 1.494 0 0 0-.85 1.8 1.47 1.47 0 0 0 1.02 1.02q.186.048.378.052H11a1 1 0 0 1 0 2H9.429a3.8 3.8 0 0 1-.86-.121 3.5 3.5 0 0 1-.451-6.589 6.4 6.4 0 0 1 .057-2.731 6 6 0 0 1 11.368-.859c.136.326.286.359.587.427l.176.042a5.088 5.088 0 0 1-.083 9.8A1 1 0 0 1 20 23M2.073 14a1 1 0 0 1-.5-1.866l2.248-1.3A5.5 5.5 0 0 1 3.6 10H1a1 1 0 0 1 0-2h2.589a5.62 5.62 0 0 1 .205-.81L1.551 5.915a1 1 0 1 1 .989-1.738l2.239 1.272q.294-.35.643-.649L4.134 2.572a1 1 0 0 1 1.732-1l1.29 2.235c.148-.052.3-.1.451-.135q.197-.048.393-.083V1a1 1 0 0 1 2 0v2.6q.408.075.8.212l1.282-2.255a1 1 0 0 1 1.739.988l-1.279 2.248q.33.279.615.606l2.274-1.267a1 1 0 1 1 .994 1.736L14.167 7.16a2.02 2.02 0 0 1-2.521-.45 3.5 3.5 0 0 0-3.557-1.1A3.43 3.43 0 0 0 5.612 8.1a3.51 3.51 0 0 0 1.055 3.514A1 1 0 0 1 5.333 13.1a5 5 0 0 1-.517-.53l-2.244 1.3a1 1 0 0 1-.499.13"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-thunderstorm-sun_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrThunderstormSun;
